import { render, staticRenderFns } from "./TaskKanban.vue?vue&type=template&id=2b0ec8e6&"
import script from "./TaskKanban.vue?vue&type=script&lang=js&"
export * from "./TaskKanban.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports